import type { ProductDetailsResponse } from "@repo/shared/types";
import { getWithToken } from "../_client";

/**
 * Product details for the portfolio-display info modal on the PUBLIC surface.
 * Same service and response shape as the internal
 * `/internal/flow-instances/products/:id/details` endpoint; authenticated by
 * the public session token instead of an advisor session.
 */
export function getPublicProductDetails(token: string, productId: string, lang: string) {
  return getWithToken<ProductDetailsResponse>(
    `/public/flow/snapshots/products/${productId}/details?lang=${encodeURIComponent(lang)}`,
    token,
  );
}
